import { render, staticRenderFns } from "./SupplierTenders.vue?vue&type=template&id=38c11b67"
import script from "./SupplierTenders.vue?vue&type=script&lang=js"
export * from "./SupplierTenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports